import React, { useCallback } from "react";

import classnames from "classnames";
import isIntuit from "Intuit/isIntuit";
import fetchWithCSRFToken from "Utils/fetchWithCSRFToken";

import useAsync from "Common/useAsync";

import makeBem from "Utils/makeBem";

const bem = makeBem("PricingStatusBanner");

const getPricingStatus = (geographicState, targetEffectiveDate) =>
  fetchWithCSRFToken(`/api/v2/pricing-status?geographicState=${geographicState}&targetEffectiveDate=${targetEffectiveDate}`, { method: "get" }).then((res) =>
    res.json(),
  );

function PricingStatusBanner({ geographicState, targetEffectiveDate }) {
  const getPricing = useCallback(() => getPricingStatus(geographicState, targetEffectiveDate), [geographicState]);

  const { data, error, isLoading } = useAsync(getPricing, true);

  if (isLoading) {
    return null;
  }
  if (error) {
    return (
      <div className={classnames(bem("wrapper"))}>
        <div className={classnames(bem(), bem(null, isIntuit() && "intuit"))}>
          There may be some insurance carriers in {geographicState} who have not yet published pricing. More plan options may be shown as they become available.
        </div>
      </div>
    );
  }
  if (data && data.allCarriersReleased) {
    return null;
  }
  return (
    <div className={classnames(bem("wrapper"))}>
      <div className={classnames(bem(), bem(null, isIntuit() && "intuit"))}>
        We have not received {data.year} pricing for {data.missingCarriers}. More plan options will be shown as they become available.
      </div>
    </div>
  );
}

export default PricingStatusBanner;
